var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 32,
    viewBox: "0 0 27 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2 0L27 10.6667V28.2667C27 30.3285 25.3076 32 23.22 32H3.78C1.69236 32 0 30.3285 0 28.2667V3.73333C0 1.67147 1.69236 0 3.78 0H16.2Z",
    fill: "url(#paint0_linear_448_54116)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 10.667H20.1709C18.0833 10.667 16.2 8.80696 16.2 6.7451V0.000325203L27 10.667Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27706 26.7469C6.95508 26.7469 7.49297 26.4166 7.79581 25.8809H7.80938V26.6666H8.55971V20.2246H7.77321V22.7782H7.75513C7.47489 22.2693 6.93248 21.9434 6.25898 21.9434C5.07472 21.9434 4.26562 22.8898 4.26562 24.3451C4.26562 25.8005 5.07924 26.7469 6.27706 26.7469ZM6.42623 22.6264C7.23532 22.6264 7.77773 23.3094 7.77773 24.3451C7.77773 25.3853 7.23532 26.0639 6.42623 26.0639C5.59453 26.0639 5.0702 25.3987 5.0702 24.3451C5.0702 23.296 5.59453 22.6264 6.42623 22.6264Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5701 26.7469C12.8674 26.7469 13.7443 25.8228 13.7443 24.3451C13.7443 22.863 12.8674 21.9434 11.5701 21.9434C10.2683 21.9434 9.39141 22.863 9.39141 24.3451C9.39141 25.8228 10.2683 26.7469 11.5701 26.7469ZM11.5701 26.0639C10.7384 26.0639 10.1915 25.4389 10.1915 24.3451C10.1915 23.2514 10.7384 22.6264 11.5701 22.6264C12.4018 22.6264 12.9442 23.2514 12.9442 24.3451C12.9442 25.4389 12.4018 26.0639 11.5701 26.0639Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4451 23.546C18.3457 22.7112 17.6451 21.9434 16.4699 21.9434C15.1726 21.9434 14.3093 22.8809 14.3093 24.3451C14.3093 25.8407 15.1771 26.7469 16.4789 26.7469C17.5456 26.7469 18.3321 26.0951 18.4542 25.171H17.6813C17.5456 25.7291 17.1253 26.0639 16.4834 26.0639C15.6698 26.0639 15.1093 25.4255 15.1093 24.3451C15.1093 23.2916 15.6608 22.6264 16.4744 22.6264C17.166 22.6264 17.5637 23.0416 17.6767 23.546H18.4451Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8408 24.8987L21.9663 26.6666H22.8387L21.2747 24.3139L22.8613 22.0237H21.9844L20.8679 23.7648H20.8498L19.7198 22.0237H18.8429L20.4159 24.3451L18.8158 26.6666H19.6882L20.8227 24.8987H20.8408Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_448_54116",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5895FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387CF4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.ff7800cf18449fcff36271473a3d1a0b.svg";
export { ForwardRef as ReactComponent };